import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-charge-cabinet-close",
  "use": "icon-charge-cabinet-close-usage",
  "viewBox": "0 0 64 73",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 73\" id=\"icon-charge-cabinet-close\">\r\n  <g id=\"icon-charge-cabinet-close_guanmen\" transform=\"translate(-227.943 -187.475)\">\r\n    <path id=\"icon-charge-cabinet-close_路径_303\" data-name=\"路径 303\" d=\"M283.5,191.971a3.967,3.967,0,0,1,3.955,3.967v56.072a3.96,3.96,0,0,1-1.16,2.8,3.914,3.914,0,0,1-2.8,1.164H236.382a3.967,3.967,0,0,1-3.955-3.967V195.939a3.96,3.96,0,0,1,1.16-2.8,3.913,3.913,0,0,1,2.8-1.164H283.5m0-4.5H236.382a8.476,8.476,0,0,0-8.438,8.464v56.072a8.476,8.476,0,0,0,8.438,8.464H283.5a8.476,8.476,0,0,0,8.438-8.464V195.939A8.476,8.476,0,0,0,283.5,187.475Z\" transform=\"translate(0)\" />\r\n    <path id=\"icon-charge-cabinet-close_路径_304\" data-name=\"路径 304\" d=\"M370.545,600.436a4.129,4.129,0,1,0,4.129,4.129A4.131,4.131,0,0,0,370.545,600.436Z\" transform=\"translate(-124.386 -370.795)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/charge-cabinet-close.svg
// module id = 6gTf
// module chunks = 5